import React, { createContext, useEffect, useState } from "react";
import "./styles/_index.scss";
import Layout from "./layouts/Layout";
import { getCookieValue } from "./components/utils/CheckCookie";
import ReactGA from "react-ga4";

export const LoadingContext = createContext();

function App() {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const cookieConsent = getCookieValue("cookieConsent");
        if (cookieConsent === "accepted" && process.env.NODE_ENV === "production") {
            ReactGA.initialize("G-99DXPTYBRY");
            ReactGA.send({
                hitType: "pageview",
                page: window.location.pathname + window.location.search,
                title: window.location.pathname,
            });
        }
    }, []);

    return (
        <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
            <div className="App">
                <Layout />
            </div>
        </LoadingContext.Provider>
    );
}

export default App;
